import { Navigate } from 'react-router-dom';
import { useAdminAccess } from '../../hooks/useAdminAccess';
import type { AdminRole, AdminCompanyScope } from '../../stores/adminAuthStore';
import { adminLoginPath, adminPath } from '../../lib/adminPaths';

interface AdminAuthGuardProps {
  children: React.ReactNode;
  requireRoles?: AdminRole[];
  requireScope?: AdminCompanyScope;
}

export function AdminAuthGuard({ children, requireRoles, requireScope }: AdminAuthGuardProps) {
  const { isAuthenticated, admin, requireRole, hasScope } = useAdminAccess();

  if (!isAuthenticated || !admin) {
    return <Navigate to={adminLoginPath} replace />;
  }

  if (requireRoles && requireRoles.length > 0 && !requireRole(requireRoles)) {
    return <Navigate to={adminPath('dashboard')} replace />;
  }

  if (requireScope && !hasScope(requireScope)) {
    return <Navigate to={adminPath('dashboard')} replace />;
  }

  return <>{children}</>;
}
